import { gql } from "@apollo/client";

export const GET_TRANSACTION_TRAVEL_DATA = gql`
  query transactionTravelData($id: ID!) {
    transaction(id: $id) {
      id
      travelData {
        airline {
          ticketNumber
          recordLocator
          passengerName
          issuingCarrier
          ticketIssueDate
          travelAgencyName
          travelAgencyCode
          totalFare {
            amount
            currencyCode
          }
          totalFees {
            amount
            currencyCode
          }
          totalTaxes {
            amount
            currencyCode
          }
          segments {
            travelDate
            carrierCode
            flightNumber
            serviceClass
            fareBasisCode
            departureAirportCode
            arrivalAirportCode
            fare {
              amount
              currencyCode
            }
          }
          ancillaryFees {
            feeType
            amount {
              amount
              currencyCode
            }
          }
        }
        lodging {
          folioNumber
          checkInDate
          checkOutDate
          nights
          roomRate {
            amount
            currencyCode
          }
          roomTax {
            amount
            currencyCode
          }
          foodBeverageCharges {
            amount
            currencyCode
          }
          nonRoomCharges {
            amount
            currencyCode
          }
          prepaidExpenses {
            amount
            currencyCode
          }
          totalTax {
            amount
            currencyCode
          }
          totalCharges {
            amount
            currencyCode
          }
        }
        carRental {
          agreementNumber
          vehicleClass
          rateFrequency
          rentalRate {
            amount
            currencyCode
          }
          weeklyRate {
            amount
            currencyCode
          }
          daysRented
          pickupDate
          returnDate
          pickupCity
          returnCity
          insuranceCharges {
            amount
            currencyCode
          }
          fuelCharges {
            amount
            currencyCode
          }
          oneWayDropOffCharges {
            amount
            currencyCode
          }
          totalTax {
            amount
            currencyCode
          }
        }
        rail {
          ticketNumber
          travelDate
          departureStation
          arrivalStation
          ticketClass
          numberOfAdults
          numberOfChildren
          serviceAmount {
            amount
            currencyCode
          }
        }
      }
    }
  }
`;
